import React from 'react'
import { func, string } from 'prop-types'
import classNames from 'classnames'

import Button from 'components/atoms/Button'
import Typography from 'components/atoms/Typography'

const onboardingTooltip = ({
  text,
  arrow,
  completeFunc,
  closeFunc,
  backFunc,
  nextFunc,
}) => {
  const className = classNames(
    'onboarding-tooltip',
    arrow
  )
  return (
    <div className={className}>
      <Typography component="p" variant="subbody" className="onboarding-tooltip__text">{text}</Typography>
      <div className="onboarding-tooltip__footer" >
        {
          closeFunc &&
          <Button variant="info" className="onboarding-tooltip__btn m-r-md" onClick={closeFunc}>Tutup</Button>
        }
        {
          backFunc &&
          <Button variant="info" className="onboarding-tooltip__btn m-r-md" onClick={backFunc}>Kembali</Button>
        }
        {
          nextFunc &&
          <Button variant="orange" className="onboarding-tooltip__btn bold" onClick={nextFunc}>Selanjutnya</Button>
        }
        {
          completeFunc &&
          <Button variant="orange" className="onboarding-tooltip__btn bold" onClick={completeFunc}>Saya Mengerti</Button>
        }
      </div>
      <style jsx>
        {`
          .onboarding-tooltip {
            arrow: relative;
            &.bottom {
              &::after {
                content: "";
                position: absolute;
                bottom: -10px;
                left: 45%;
                border-left: 12px solid transparent;
                border-right: 12px solid transparent;
                border-bottom: 12px solid #fff;
                transform: rotate(180deg);
              }
            }
            &.top {
              &::after {
                content: "";
                position: absolute;
                top: -10px;
                left: 45%;
                border-left: 12px solid transparent;
                border-right: 12px solid transparent;
                border-bottom: 12px solid #fff;
              }
            }

            :global(&__text) {
              color: #1e3f6b !important;
              padding-bottom: 8px;
            }

            :global(&__footer) {
              display: flex;
            }

            :global(&__btn) {
              padding: 15px;
              flex: 1;
              :global(&.bold) {
                font-weight: bold;
              }
              :global(&.solid) {
                background-color: #e3ecf5;
                color: #6b8fbc;
              }
            }
          }
        `}
      </style>
    </div>
  )
}

onboardingTooltip.propTypes = {
  text: string.isRequired,
  arrow: string,
  completeFunc: func,
  closeFunc: func,
  backFunc: func,
  nextFunc: func,
}

export default onboardingTooltip
